import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getAll from 'utils/getAll'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  getValues: Function
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  setContacts: Function
  setStates: Function
  setAllStates: Function
  setCountries: Function
  setCurrentCountry: Function
  currentCustomer?: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    getAll(apiUrls.states).then((data) => {
      props.setStates(data)
      props.setAllStates(data)
    })
    getAll(apiUrls.users).then((data) => {
      props.setContacts(data)
    })
    getAll(apiUrls.countries)
      .then((data) => props.setCountries(data))
      .then(() => {
        loadRecord(apiUrls.customers, apiUrls.actionMyCustomer, [
          'country',
          'state',
          'primaryContact',
        ]).then((data) => {
          props.reset(data)

          props.setDataLoaded(true)
          props.setShowOverlay(false)
        })
      })
  }, [props.currentCustomer])
}

export default useInit
